// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__igVmn","header":"ReportDetails_header__ardIQ","title":"ReportDetails_title__2GJhd","left":"ReportDetails_left__1M-xu"};